/** Endpoints #10, #16, #17 — scrape history, manual enqueue, run detail. */

import type {
  RunDetailResponse,
  RunsListResponse,
  RunsQuery,
  ScrapeRequestBody,
  ScrapeResponse,
} from '@lw/shared';
import { apiJson } from './client';

/** #10 `GET /api/profiles/:id/runs` */
export function listProfileRuns(
  profileId: number,
  params?: Partial<RunsQuery>,
  signal?: AbortSignal,
): Promise<RunsListResponse> {
  return apiJson<RunsListResponse>(`/profiles/${profileId}/runs`, {
    query: { offset: params?.offset, limit: params?.limit },
    signal,
  });
}

/** #17 `GET /api/runs/:id` */
export function getRun(runId: number, signal?: AbortSignal): Promise<RunDetailResponse> {
  return apiJson<RunDetailResponse>(`/runs/${runId}`, { signal });
}

/** #16 `POST /api/scrape` — the server dedupes the profile/group union. */
export function startScrape(body: ScrapeRequestBody): Promise<ScrapeResponse> {
  return apiJson<ScrapeResponse>('/scrape', { method: 'POST', body });
}
